import React from "react";
import { Link } from "react-router-dom";

import INFO from "../../data/user";

import "./styles/logo.css";

const Logo = (props) => {
  let { width, link } = props;
  // const [modalIsOpen, setModalIsOpen] = useState(false);

  if (link === undefined) {
    link = true;
  }

  const imageElement = (
    <img src={INFO.main.logo} alt="logo" width={width} className="logo" />
  );

  return (
    <React.Fragment>
      <div className="logo-container">
        {link ? <Link to="/">{imageElement}</Link> : imageElement}

        {/* <Modal
          // isOpen={modalIsOpen}
          // onRequestClose={() => setModalIsOpen(false)}
          className={`modal ${modalIsOpen ? "open" : ""}`}
          overlayClassName="overlay"
        >
          <button> close </button>
        </Modal> */}
      </div>
    </React.Fragment>
  );
};

export default Logo;
